<template>
  <div class="modal show" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Details</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
              <table class="table table-head-fixed text-nowrap">
                <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Comments</th>
                  <th>Reference Id</th>
                  <th>Created</th>
                  <th>Updated</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(row, index) in list" >
                  <td>{{index +1}}</td>
                  <td>{{row.comments}}</td>
                  <td>{{row.source_reference_id  ? row.source_reference_id : 'N/A'}}</td>
                  <td>{{customFormatDateTime(row.created_at)}}</td>
                  <td>{{customFormatDateTime(row.updated_at)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn light btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    setupData() {
    }
  },
  watch: {
    show() {
      console.log(this.data,'add edit')
      this.list = this.data.with_drawal_request_details
      this.setupData()
    }
  }
}
</script>

